(function () {
  'use strict';

  angular.module('unit.deal.lead').factory('UnitDealLead', UnitDealLead);

  UnitDealLead.$inject = ['$resource'];

  function UnitDealLead($resource) {
    return $resource(
      '/api/',
      {},
      {
        create: { method: 'POST', url: '/api/lead/create' },
        update: { method: 'POST', url: '/api/lead/:id/update' },
        getCustomFields: {
          method: 'GET',
          url: '/api/deal/custom_fields',
          isArray: true,
          cache: true,
        },
        updateDeal: { method: 'POST', url: '/api/deal/:id/update' },
        extendDeal: { method: 'POST', url: '/api/deal/:id/extend_booking' },
        createAdditionalContact: {
          method: 'POST',
          url: '/api/lead/:id/create_additional',
        },
        updateAdditionalContact: {
          method: 'POST',
          url: '/api/lead/:id/update_additional',
          isArray: true,
        },
        cancelDeal: { method: 'POST', url: '/api/deal/:id/cancel' },
        updateUnitResale: {
          method: 'POST',
          url: '/api/unit/:id/update_resale',
        },
        updateLeadAssn: {
          method: 'POST',
          url: '/api/unit_lead_assn/:id/resale',
        },
        updateUnitParams: {
          method: 'POST',
          url: '/api/unit/:id/update_params',
        },
      },
    );
  }
})();
